import { AppThunk } from '../../../../../store/types';
import { BookEffects } from '../../../../../effects/bookEffects';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { getAudioById } from '../../../../../store/models/selectors';
import { IBook, IBookReaderError } from '../../../../../../common/endlessBook/embed';

export class BookTabEvents {

	public static onCreateBook(): AppThunk {
		return async (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			// already on this tab
			if (audioId) await BookEffects.createBook(audioId, false);
		}
	}

	public static onLoadBookHost(): AppThunk {
		return () => BookEffects.loadBookHost();
	}

	public static onGetToken(): AppThunk<Promise<string>> {
		return () => BookEffects.getToken();
	}

	public static onBook(book: IBook): AppThunk {
		return () => BookEffects.onBookLoaded(book);
	}

	public static onReaderError(error: IBookReaderError): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			const bookId = audioId ? getAudioById(getState(), audioId)?.bookId : null;
			if (audioId && bookId) return BookEffects.onReaderError(audioId, bookId, error);
		}
	}

}
